//トップページ　キービジュアルスライダー
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade} from 'swiper/modules';

export function idxFunc() {
  let indexTop = $("#indexTop").length;
  let resizecheck = $('#responsibleCheck').width();

  if(indexTop){
    let resizecheck = $('#responsibleCheck').width();
    let resizecheck2 = 0;
    
    $(window).on('load resize', function () {
      resizecheck = $('#responsibleCheck').width();
    });

    //FVアニメーション
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms))
    
    //スワイプ実行処理
    let topSwiper, topOptions;
    topOptions = {
      modules: [Pagination, Navigation, Autoplay, EffectFade],
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 5000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        reverseDirection: false
      },
      speed: 3000,
    };
    function initTopSwiper() {
      topSwiper = new Swiper('#topMainviewSlide', topOptions);
    }
    
    wait(0)
    .then(() =>{
      $(".firstMainviewImgAnime").addClass('isShow');
      return wait(1000)
    })
    .then(() => {
      $('.firstMainviewTxtAnime').addClass('isShow');
      return wait(400)
    })
    .then(() => {
      initTopSwiper();
    })

    function indexCommonAnimeFunc() {
      $('.commonTwoColumn').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 300) {
          wait(0)
          .then(() => {
            if (!$(this).find('.imgBox').hasClass('isShow')) {
              $(this).find('.imgBox').addClass('isShow');
            }
            return wait(700)
          })
          .then(() => {
              if (!$(this).find('.commonAnimeTit').hasClass('isShow')) {
                $(this).find('.commonAnimeTit').addClass('isShow');
                $(this).find('.commonAnimeTxt').addClass('isShow');
                $(this).find('.moreBtn').addClass('isShow');
              }
              return wait(100)
          })
        }
      });
      
      $('.commonThreeColumn').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 300) {
          wait(0)
          .then(() => {
            if (!$(this).find('.imgBox01').hasClass('isShow')) {
              $(this).find('.imgBox01').addClass('isShow');
            }
            return wait(700)
          })
          .then(() => {
            if (!$(this).find('.imgBox02').hasClass('isShow')) {
              $(this).find('.imgBox02').addClass('isShow');
            }
            return wait(700)
          })
          .then(() => {
              if (!$(this).find('.commonAnimeTit').hasClass('isShow')) {
                $(this).find('.commonAnimeTit').addClass('isShow');
                $(this).find('.commonAnimeTxt').addClass('isShow');
                $(this).find('.moreBtn').addClass('isShow');
              }
              return wait(100)
          })
        }
      });
      
      $('.commonFourColumn').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 300) {
          wait(0)
          .then(() => {
            if (!$(this).find('.imgBox01').hasClass('isShow')) {
              $(this).find('.imgBox01').addClass('isShow');
            }
            return wait(700)
          })
          .then(() => {
              if (!$(this).find('.commonAnimeTit').hasClass('isShow')) {
                $(this).find('.commonAnimeTit').addClass('isShow');
                $(this).find('.commonAnimeTxt').addClass('isShow');
                $(this).find('.moreBtn').addClass('isShow');
              }
              return wait(700)
          })
          .then(() => {
            if (!$(this).find('.imgBox02').hasClass('isShow')) {
              $(this).find('.imgBox02').addClass('isShow');
            }
            return wait(300)
          })
          .then(() => {
            if (!$(this).find('.imgBox03').hasClass('isShow')) {
              $(this).find('.imgBox03').addClass('isShow');
            }
            return wait(700)
          })
        }
      });

      $('.services').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 300) {
          wait(0)
          .then(() => {
            if (!$(this).find('.imgBox').hasClass('isShow')) {
              $(this).find('.imgBox').addClass('isShow');
            }
            return wait(1000)
          })
          .then(() => {
              if (!$(this).find('.commonAnimeTit').hasClass('isShow')) {
                $(this).find('.commonAnimeTit').addClass('isShow');
                $(this).find('.commonAnimeTxt').addClass('isShow');
                $(this).find('.moreBtn').addClass('isShow');
              }
              return wait(100)
          })
          .then(() => {
            
            return wait(700)
          })
        }
      });

    }indexCommonAnimeFunc();

    $(window).on('load scroll', function () {
      indexCommonAnimeFunc();
    });


    //services 画像切り替え
    const servicesNav01 = $('#servicesNav01');
    const servicesNav02 = $('#servicesNav02');
    const servicesNav03 = $('#servicesNav03');
    const servicesNav04 = $('#servicesNav04');
    
    const servicesImg01 = $('#servicesImg01');
    const servicesImg02 = $('#servicesImg02');
    const servicesImg03 = $('#servicesImg03');
    const servicesImg04 = $('#servicesImg04');
    const servicesImg05 = $('#servicesImg05');
    
    const commonAnimeImg01 = $('#servicesImg01 .commonAnimeImg');
    const commonAnimeImg02 = $('#servicesImg02 .commonAnimeImg');
    const commonAnimeImg03 = $('#servicesImg03 .commonAnimeImg');
    const commonAnimeImg04 = $('#servicesImg04 .commonAnimeImg');
    const commonAnimeImg05 = $('#servicesImg05 .commonAnimeImg');

    let fadeSpeed = 600;

    const resetImgFunc = function () { 
      commonAnimeImg01.css({opacity:'0'}).animate({opacity:'1'},fadeSpeed);
      servicesImg01.after(servicesImg02,servicesImg03,servicesImg04,servicesImg05);
    };

    
    servicesNav01.hover(function () {
      if (resizecheck == '1') {
        commonAnimeImg02.css({opacity:'0'}).animate({opacity:'1'},fadeSpeed);
        servicesImg01.before(servicesImg02);
      }
    }, function () {
      if (resizecheck == '1') {
        resetImgFunc();
      }
    });
    servicesNav02.hover(function () {
      if (resizecheck == '1') {
        commonAnimeImg03.css({opacity:'0'}).animate({opacity:'1'},fadeSpeed);
        servicesImg01.before(servicesImg03);
      }
    }, function () {
      if (resizecheck == '1') {
        resetImgFunc();
      }
    });
    servicesNav03.hover(function () {
      if (resizecheck == '1') {
        commonAnimeImg04.css({opacity:'0'}).animate({opacity:'1'},fadeSpeed);
        servicesImg01.before(servicesImg04);
      }
    }, function () {
      if (resizecheck == '1') {
        resetImgFunc();
      }
    });
    servicesNav04.hover(function () {
      if (resizecheck == '1') {
        commonAnimeImg05.css({opacity:'0'}).animate({opacity:'1'},fadeSpeed);
        servicesImg01.before(servicesImg05);
      }
    }, function () {
      if (resizecheck == '1') {
        resetImgFunc();
      }
    });
  }
}